module.exports = require("./../../_gen/openfl/external/ExternalInterface");